export enum MapboxAddressType {
  country = 'country',
  region = 'region',
  locality = 'locality',
  postcode = 'postcode',
  district = 'district',
  place = 'place',
}
